import PropTypes from 'prop-types'

import { getContentfulField } from '../../utils/GatsbyUtils'
import { loopingIndex } from '../../utils/MathUtils'

import Image from './Image'
import LinkedProject from './LinkedProject'
import Seo from './Seo'
import Technology from './Technology'
import PortfolioProject from './PortfolioProject'


function findLinkedProjects(data) {
  const domain = getContentfulField(data, 'domain')
  const domainProjects = data.projecttemplate
  && data.projecttemplate[0]
  && data.projecttemplate[0][`${domain}Projects`]
    ? data.projecttemplate[0][`${domain}Projects`] : []

  const index = domainProjects.findIndex((({ slug }) => data.slug === slug))
  const totalProjects = domainProjects.length

  const nextIndex = index === totalProjects - 1 ? 0 : index + 1
  const previousIndex = index === 0 ? totalProjects - 1 : index - 1

  const next = domainProjects[nextIndex]
  const previous = domainProjects[previousIndex]

  const projects = [...domainProjects]

  projects.splice(index, 1)
  const related = []

  const entryIndex = index

  for (let i = 0; i < projects.length; i++) {
    related.push(projects[loopingIndex(entryIndex + i, projects.length)])
  }

  return { related, next, previous }
}

const Project = (data) => {
  const linkedProjects = findLinkedProjects(data)

  return {
    slug: data.slug,
    title: data.title,
    subTitle: data.subTitle,
    credits: data.credits,
    description: getContentfulField(data, 'description'),
    technologies: data.technologies?.map(t => Technology(t)),
    domain: data.domain,
    pictures: data.pictures?.map(p => Image(p)),
    thumbnail: Image(data.thumbnail),
    seo: Seo(data.seo),
    relatedProjects: linkedProjects.related.filter((a, i) => i < 3).map(p => PortfolioProject(p)),
    previousProject: LinkedProject(linkedProjects.next),
    nextProject: LinkedProject(linkedProjects.previous),
    sector: data.sector,
    tags: data.tags,
    qrcode: Image(data.qrcode),
    link: data.link
  }
}

Project.propTypes = PropTypes.shape({
  slug: PropTypes.string.isRequired,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  credits: PropTypes.string,
  domain: PropTypes.string.isRequired,
  pictures: PropTypes.arrayOf(Image.propTypes),
  thumbnail: Image.propTypes.isRequired,
  seo: Seo.propTypes.isRequired,
  previousProject: LinkedProject.propTypes.isRequired,
  nextProject: LinkedProject.propTypes.isRequired,
  sector: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
})

Project.defaultProps = {
  title: '',
  subTitle: '',
  credits: '',
  pictures: [],
  sector: '',
  tags: [],
}

export default Project
